import {Box, IconButton, Modal} from "@mui/material";
import FilterIcon from "assets/icons/Filter";
import {useState} from "react";
import MaterialFilters from "pages/Material/list/components/MaterialFilters";
import {useOutletContext} from "react-router-dom";
import {MaterialContextProps} from "pages/Material/types";

const MaterialFilterButton = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false)


  const {
    setSelectedCategory,
    setSelectedSubcategory,
    setKeywordsFilter,
    keywordList,
    setMixedFilterValue,
    setSelectedKeywords,
    mixedFilterValue,
    selectedKeywords
  } = useOutletContext<MaterialContextProps>()

  return (
    <>
      <IconButton
        onClick={handleOpenModal}
        sx={{
          borderRadius: 2,
          width: 40,
          height: 40,
          padding: 1,
          border: '1px solid',
          borderColor: 'grey.100',
        }}>
        <FilterIcon sx={{width: 20, height: 20, color: 'primary.main'}}/>
      </IconButton>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          width: '80%',
          px: 3.5,
          py: 4
        }}>
          <MaterialFilters
            selectedKeywords={selectedKeywords}
            setSelectedKeywords={setSelectedKeywords}
            mixedFilterValue={mixedFilterValue}
            setMixedFilterValue={setMixedFilterValue}
            onCloseModal={handleCloseModal}
            keywordList={keywordList}
            setKeywordsFilter={setKeywordsFilter}
            setSelectedSubcategory={setSelectedSubcategory}
            setSelectedCategory={setSelectedCategory}
          />
        </Box>
      </Modal>
    </>
  )
}

export default MaterialFilterButton;
